import { lazy } from 'react';

export const MedicalDeviceTypeDetailsPageAsync = lazy(
  () => import('./MedicalDeviceTypeDetailsPage.tsx'),
);
